import React from 'react';
import { motion } from 'framer-motion';
import { subsidyInfo } from '../../../data/questionnaireData';
import './QuestionStep.css';

const SubsidyInfoStep = () => {
  return (
    <div className="question-step">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
      >
        <h2 className="question-title">Did you know about government subsidy?</h2>
        <p className="question-subtitle">Learn about available benefits</p>
      </motion.div>

      <motion.div
        className="subsidy-card"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
      >
        <div className="subsidy-header">
          <span className="subsidy-icon">🎁</span>
          <h3>{subsidyInfo.title}</h3>
        </div>
        <p className="subsidy-description">{subsidyInfo.description}</p>

        <div className="subsidy-amounts">
          <h4>Subsidy Amounts:</h4>
          <div className="subsidy-table">
            {subsidyInfo.amounts.map((item, index) => (
              <div key={index} className="subsidy-row">
                <span className="subsidy-capacity">{item.capacity}</span>
                <span className="subsidy-value">₹{item.subsidy.toLocaleString('en-IN')}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="subsidy-eligibility">
          <h4>Eligibility Criteria:</h4>
          <ul>
            {subsidyInfo.eligibility.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>

        <div className="subsidy-transfer">
          <p>{subsidyInfo.transferInfo}</p>
        </div>
      </motion.div>

      <motion.div
        className="info-box highlight"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4 }}
      >
        <p>✨ <strong>Great news!</strong> We'll automatically apply for the subsidy on your behalf when you choose to go solar with us.</p>
      </motion.div>
    </div>
  );
};

export default SubsidyInfoStep;

